export const GALLERY_STORAGE_METADATA_SCHEMA = "roboscientist.gallery_storage_metadata.v1" as const;
export const MAX_GALLERY_MESSAGE_LENGTH = 1_000;

export type GalleryStorageMetadata = {
  schema: typeof GALLERY_STORAGE_METADATA_SCHEMA;
  message: string;
  updatedAt: string;
};

const record = (value: unknown): Record<string, unknown> | null =>
  value !== null && typeof value === "object" && !Array.isArray(value)
    ? value as Record<string, unknown>
    : null;

export const normalizeGalleryMessage = (value: unknown): string => {
  if (typeof value !== "string") throw new Error("Gallery message must be a string.");
  const message = value.trim();
  if (message.length > MAX_GALLERY_MESSAGE_LENGTH) {
    throw new Error(`Gallery message cannot exceed ${MAX_GALLERY_MESSAGE_LENGTH} characters.`);
  }
  return message;
};

export const createGalleryStorageMetadata = (
  message: string,
  updatedAt = new Date().toISOString()
): GalleryStorageMetadata => ({
  schema: GALLERY_STORAGE_METADATA_SCHEMA,
  message: normalizeGalleryMessage(message),
  updatedAt
});

export const parseGalleryStorageMetadata = (value: unknown): GalleryStorageMetadata => {
  const metadata = record(value);
  if (!metadata || metadata.schema !== GALLERY_STORAGE_METADATA_SCHEMA
    || typeof metadata.updatedAt !== "string" || !Number.isFinite(Date.parse(metadata.updatedAt))) {
    throw new Error("Gallery storage metadata is invalid.");
  }
  return {
    schema: GALLERY_STORAGE_METADATA_SCHEMA,
    message: normalizeGalleryMessage(metadata.message),
    updatedAt: metadata.updatedAt
  };
};
